import { useDashboardBannerStore } from 'stores/useDashboardBannerStore';

interface BannerItem {
  imageUrl: string;
  internalDestination: boolean;
  destination: string;
}

interface BannerWithKey extends BannerItem {
  key: string;
}

interface BannerResult {
  firstBanners: BannerWithKey[];
  mainBanners: BannerWithKey[];
  lastBanners: BannerWithKey[];
  autoPlayInterval: number;
}

/**
 * Return banners with specific segment
 * @param customerLegalName
 */
export function useDashboardBanners(customerLegalName?: string): BannerResult | null {
  const { config, isLoaded } = useDashboardBannerStore();

  if (!isLoaded || !customerLegalName || !config) return null;

  const banners = (config.banners as Record<string, BannerItem>) || {};
  const entities = (config.entities as Record<string, string[]>) || {};
  const firstBanners = (config.firstBanners as string[]) || [];
  const lastBanners = (config.lastBanners as string[]) || [];

  const customerKey = customerLegalName.toUpperCase();
  const mainBannerKeys = entities[customerKey] || [];

  /** */
  const buildBanner = (key: string): BannerWithKey | null => {
    const banner = banners[key];
    if (!banner || !banner.imageUrl) return null;
    return { key, ...banner };
  };

  /** */
  const clean = (b: (BannerWithKey | null)[]): BannerWithKey[] =>
    b.filter(Boolean) as BannerWithKey[];

  return {
    firstBanners: clean(firstBanners.map(buildBanner)),
    mainBanners: clean(mainBannerKeys.map(buildBanner)),
    lastBanners: clean(lastBanners.map(buildBanner)),
    autoPlayInterval: Number(config.autoPlayInterval || 5000),
  };
}
